export const scrollToTop = () => {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (window.__lenis) {
    window.__lenis.scrollTo(0, { immediate: prefersReducedMotion });
  } else {
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? "auto" : "smooth" });
  }
};

export const scrollToAnchor = (id, offset = 20) => {
  const el = document.getElementById(id);
  if (!el) return false;

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const behavior = prefersReducedMotion ? "auto" : "smooth";
  const targetTop = () => el.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({ top: targetTop(), behavior });
  if (behavior === "auto") return true;

  let cancelled = false;
  const timers = [];
  const cancel = () => {
    cancelled = true;
    timers.forEach(window.clearTimeout);
    window.removeEventListener("wheel", cancel);
    window.removeEventListener("touchstart", cancel);
  };

  [900, 1700, 2600].forEach((delay) => {
    timers.push(
      window.setTimeout(() => {
        if (cancelled || !document.contains(el)) return;
        const delta = el.getBoundingClientRect().top - offset;
        if (Math.abs(delta) > 4) {
          window.scrollTo({ top: window.scrollY + delta, behavior: "auto" });
        }
      }, delay)
    );
  });

  window.addEventListener("wheel", cancel, { once: true, passive: true });
  window.addEventListener("touchstart", cancel, { once: true, passive: true });
  return true;
};
